(ns practitest.frontend.components.datepicker2
  "Native <input type=\"date\"> implementation, replacing the old custom
   calendar-grid picker so plain-date fields use the browser's own calendar."
  (:require [clojure.string :as str]
            [practitest.frontend.common.dom :as dom]
            [practitest.frontend.components.icons :as icons]
            [tick.core :as tick]))

;; yyyy-MM-dd is the format <input type="date"> requires for its value attribute
(def ^:private native-date-formatter (tick/formatter "yyyy-MM-dd"))

(defn- as-tick-date
  [value]
  (when value
    (cond
      (tick/date? value) value

      (string? value)
      (let [trimmed (str/trim value)]
        (when-not (str/blank? trimmed)
          (try
            ;; Handles both plain "2022-01-02" and instant-like
            ;; "2024-03-01T04:00:00+02:00" strings by taking the date portion
            (tick/date (subs trimmed 0 (min 10 (count trimmed))))
            (catch js/Error _ nil))))

      :else
      (try (tick/date value) (catch js/Error _ nil)))))

(defn- format-date-for-native-input
  [value]
  (when-let [date (as-tick-date value)]
    (tick/format native-date-formatter date)))

(defn- parse-native-input-value
  [datestr]
  (when-not (str/blank? datestr)
    (try
      (tick/date datestr)
      (catch js/Error _ nil))))

(defn- find-date-input
  "Find the native date input by trying multiple strategies:
   1. DOM getElementById (when the input has an id)
   2. DOM traversal from the event target (e.g. for Angular Grid filters
      or other callers that don't pass an id)"
  [field-id event]
  (or (when field-id
        (js/document.getElementById (str field-id)))
      (when-let [target (.-currentTarget event)]
        (when-let [parent (.-parentElement target)]
          (.querySelector parent "input[type='date']")))))

;; Firefox always renders its own calendar icon on native date/datetime-local
;; inputs, with no CSS way to hide it (unlike ::-webkit-calendar-picker-indicator),
;; so our custom icon would duplicate it there. Its native icon already opens
;; the picker on click, so we skip rendering ours on Firefox.
(defn firefox? []
  (some? (re-find #"Firefox" (or js/navigator.userAgent ""))))

(defn date-picker-input
  [{:keys [on-focus
           on-blur
           on-change
           value
           class
           id]
    :as   _props}]
  (let [value* (format-date-for-native-input value)]
    [:div.datepicker-input-holder
     {:class (when (firefox?) "firefox-native-picker")}
     [:input
      {:class     class
       :type      "date"
       :id        id
       :value     value*
       :on-focus  (when on-focus on-focus)
       :on-blur   (when on-blur on-blur)
       :on-change (when on-change
                    (fn [e]
                      (let [datestr (dom/event-value e)]
                        (on-change (parse-native-input-value datestr)))))}]
     (when-not (firefox?)
       [:span.datepicker-input-icon
        {:on-click (fn [e]
                     (when-let [input (find-date-input id e)]
                       ;; showPicker() opens the native picker without focusing/typing
                       ;; into the input; not supported in all browsers, and can throw
                       ;; even when present (e.g. iframe/permission restrictions) - a
                       ;; plain click, which also opens the picker, is the fallback.
                       ;; js-invoke (not .showPicker) since the CLJS compiler can't
                       ;; infer input's type well enough to resolve a dot-method call.
                       (try
                         (js-invoke input "showPicker")
                         (catch js/Error _
                           (.click input)))))}
        [icons/mux-calendar-manual]])]))
